import { MenuItem } from "./blocs/menu-item";
import { MenuPatientGenerateReference } from "./blocs/menu-patient-generate-reference";
import { MenuPatientSearchByReference } from "./blocs/menu-patient-search-by-reference";
import "./page-home.css";

export default function PageHome() {
  return (
    <div id="home" className="reduce-width">
      <h1 id="page_home" className="text-center">
        <img src="/static/img/home.gif" />
        Home
      </h1>
      <div className="grid">
        <MenuPatientSearchByReference />
        <MenuPatientGenerateReference />
        <MenuItem
          title="Search Patients"
          requires="read"
          versalIcon="/static/img/patientsSearch.gif"
          toRoute="/search"
        >
          Search a patient
        </MenuItem>
        <MenuItem
          title="Consultations Planned"
          requires="read"
          versalIcon="/static/img/consultOfDay.gif"
          toRoute="/report/consultations-planned"
        >
          Have a list of the consultations of the day
        </MenuItem>
        <MenuItem
          title="Activity Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/activity"
        >
          If you want to know your activity, choose this report.
        </MenuItem>
        <MenuItem
          title="Cash Register Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/cash-register"
        >
          If you want to know what is paid according to what is asked.
        </MenuItem>
        <MenuItem
          title="Financial Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/financial"
        >
          Follow up of the finances.
        </MenuItem>
        <MenuItem
          title="Statistical Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/statistical"
        >
          If you want to know the activity of the SARPV CDC on a period.
        </MenuItem>
        <MenuItem
          title="Surgical Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/surgical"
        >
          Follow up of the surgical activity of the period.
        </MenuItem>
        <MenuItem
          title="Surgical Suggestion Report"
          requires="reporting"
          versalIcon="/static/img/reports.gif"
          toRoute="/report/surgical-suggestion"
        >
          List the suggestions for surgeries.
        </MenuItem>
        <MenuItem
          title="My profile"
          requires="profile"
          versalIcon="/static/img/users.png"
          toRoute="/profile"
        >
          Manage your profile.
        </MenuItem>
        <MenuItem
          title="Users Management"
          requires="manage_users"
          versalIcon="/static/img/users.png"
          toRoute="/user"
        >
          Manage the users of Cryptomedic.
        </MenuItem>
        <MenuItem
          title="Cron"
          requires="admin"
          versalIcon="/static/img/clock.svg"
          toLocation="/api/admin/cron"
        >
          Trigger cron manually
        </MenuItem>
      </div>
    </div>
  );
}
